import * as React from "react";
import { cx } from "@nju/css";
import { Icon } from "@nju/icons";
import { Button, Loader, Separator, Text } from "@nju/ui";
import { formatPhoneNumber, POSITIVE_DIGITS } from "@nju/utils";
import { INumbers } from "./chooseNewNumber.machine";
import { IChooseNewNumberFormType } from "./types";

interface IChooseNewNumberWidgetProps {
  flow: IChooseNewNumberFormType;
  isLoading: boolean;
  listOfNumbers: INumbers[];
  handleSetSelectedNumber: (number: string) => void;
  handleFetchNewNumbers: () => void;
  selectedNumber: string;
}

export function ChooseNewNumberWidget({
  flow,
  isLoading,
  listOfNumbers,
  handleSetSelectedNumber,
  handleFetchNewNumbers,
  selectedNumber,
}: IChooseNewNumberWidgetProps) {
  return (
    <>
      <form>
        <div
          className="flex from-tablet:justify-left only-mobile:justify-center flex-wrap gap-4 relative rounded-[25px] p-[4px] only-mobile:gap-2"
          data-cy="new-number-form"
        >
          {isLoading && (
            <div className="absolute top-8 left-10 only-mobile:left-8">
              <Loader size="60" />
            </div>
          )}
          {listOfNumbers &&
            listOfNumbers.map((number, index, array) => {
              return (
                // Do Api wysyłamy msisdnToken, który, teoretycznie może nie przyjść razem z numerem bo jest opcjonalny,
                // dlatego jeżeli nie dostaniemy z Api tokena,
                // to wtedy nie ma sensu pokazywać numeru bo i tak on nie przejdzie dalej
                number?.msisdnToken && (
                  <React.Fragment key={`${number.id}-switcher`}>
                    <input
                      checked={number.msisdnToken === selectedNumber}
                      className="absolute clip-0 h-microgap w-microgap border-none overflow-hidden [&:checked+label]:border-cerulean"
                      id={number.id}
                      key={number.id}
                      name={number.id}
                      onChange={() => {
                        handleSetSelectedNumber(number.msisdnToken as string);
                      }}
                      type="radio"
                      value={number.value}
                    />
                    <label
                      className={cx(
                        "flex items-center justify-center text-center min-h-[40px] rounded-[80px] border-2 border-geyser text-size-20 px-2 py-3 cursor-pointer transition-all duration-[0.3s] ease-in only-mobile:w-[140px] only-mobile:h-[45px] only-mobile:text-size-16 hover:border-cerulean",
                        {
                          "w-[210px]": flow === "NEW_NUMBER",
                          "w-[240px]": flow === "CHANGE_NUMBER",
                          "border-2 border-geyser text-geyser pointer-events-none":
                            isLoading,
                          "from-tablet:hidden": index + 1 === array.length,
                        },
                      )}
                      htmlFor={number.id}
                    >
                      {formatPhoneNumber(
                        number.value,
                        POSITIVE_DIGITS,
                        " ",
                        undefined,
                        true,
                      )}
                    </label>
                  </React.Fragment>
                )
              );
            })}
        </div>
      </form>
      <Separator size="xs" tone="invisible" />
      <div className="flex items-center justify-end">
        <Button onPress={handleFetchNewNumbers} size="inline" variant="simple">
          <Text className="pr-3">zobacz inne numery</Text>
          <Icon name="sync" tone="accent" />
        </Button>
      </div>
    </>
  );
}
